import { Vue, Component } from 'vue-property-decorator';
import store from '@/store';

@Component
export default class Mixin extends Vue {
  public HasAccess(alias: string): boolean {
    return store.getters['dashboard/permissions/HasAccess'](alias);
  }

  public get isDesktop(): boolean {
    return this.$vuetify.breakpoint.lgAndUp;
  }

  public get isMobile(): boolean {
    return !this.isDesktop;
  }
}
